import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoadingSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	style: {
		margin: "auto",
		background: "none",
		display: "block",
		shapeRendering: "auto"
	},
	width: "24px",
	height: "24px",
	viewBox: "0 0 100 100",
	preserveAspectRatio: "xMidYMid",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		fill: "none",
		stroke: "#ffffff",
		strokeWidth: 4,
		r: 24,
		strokeDasharray: "113.09733552923255 39.69911184307752",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			repeatCount: "indefinite",
			dur: "1s",
			values: "0 50 50;360 50 50",
			keyTimes: "0;1"
		})
	})
});
export { SvgLoadingSmall as ReactComponent };
